"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
function addOrderItemAdjustment(event, order) {
    var _a;
    const matchingOrdertItem = (_a = order.orderItems) === null || _a === void 0 ? void 0 : _a.find(item => {
        return (item.product.id === event.productId &&
            !domain_1.EXCLUDED_ITEM_STATUSES.includes(item.status));
    });
    if (matchingOrdertItem) {
        // apply adjustment to this item
        matchingOrdertItem.adjustments = [
            ...(matchingOrdertItem.adjustments || []),
            event.adjustment,
        ];
        matchingOrdertItem.discountAmount =
            (0, computePrice_1.computeOrderItemDiscount)(matchingOrdertItem);
    }
    return order;
}
/**
 * Adds a Adjustment to an order.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type AddOrderAdjustment
 * @param prevState
 */
function default_1(event, prevState) {
    var _a;
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    if (event.productId) {
        addOrderItemAdjustment(event, order);
    }
    else {
        const orderAdjustments = (order === null || order === void 0 ? void 0 : order.adjustments) || [];
        const rewardAdjustments = orderAdjustments.filter(adj => adj.adjustmentType == domain_1.AdjustmentType.REWARD);
        if ((_a = event.adjustment) === null || _a === void 0 ? void 0 : _a.allowOnPaymentType) {
            order.adjustments = [...orderAdjustments, event.adjustment];
        }
        else {
            order.adjustments = event.adjustment
                ? [...rewardAdjustments, event.adjustment]
                : rewardAdjustments;
        }
    }
    return { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
}
exports.default = default_1;
//# sourceMappingURL=addAdjustments.js.map